import CardViewCorrelatedServiceComponent from "./card-view-correlated-service";
import * as detailSlice from "@/common/components/announcement-detail/detail.slice";
import { useDispatch } from "react-redux";

function CardViewCorrelatedService({
  item,
  fromAdmin,
  allAnnouncements,
  announcement,
  offer,
}) {
  const dispatch = useDispatch();
  const handleServiceAdd = () => {
    if (!fromAdmin) {
      dispatch(
        detailSlice.updateOfferWithService({
          service: { ...item },
        })
      );
    }
  };

  return (
    <CardViewCorrelatedServiceComponent
      title={item.title}
      description={item.description}
      fromAdmin={fromAdmin}
      image={item.imageFileInfo?.base64}
      isInOffer={item.isInOffer}
      isSelectable={
        !fromAdmin
          ? isServiceSelectable(offer, announcement, allAnnouncements, item)
          : false
      }
      onServiceAdd={handleServiceAdd}
    />
  );
}

function isServiceSelectable(offer, announcement, allAnnouncements, item) {
  const selectedCorrelatedAnnouncements = getOfferWithoutCurrentAnnouncement(
    offer,
    announcement
  );

  let isSelectable = true;
  selectedCorrelatedAnnouncements.forEach((correlatedAnnouncementId) => {
    let correlatedServicesList = getCorrelatedServiceList(
      allAnnouncements,
      correlatedAnnouncementId
    );
    if (!correlatedServicesList.includes(item.id)) {
      isSelectable = false;
      return;
    }
  });
  return isSelectable;
}

function getCorrelatedServiceList(allAnnouncements, announcementId) {
  return allAnnouncements.find(({ id }) => id === announcementId)
    ?.correlatedServices;
}

function getOfferWithoutCurrentAnnouncement(offer, currentAnnouncement) {
  let list = [];
  offer.correlatedAnnouncements.forEach((announcementId) => {
    if (announcementId !== currentAnnouncement.id) {
      list.push(announcementId);
    }
  });
  return list;
}

export default CardViewCorrelatedService;
